import React from 'react';
export const FormattedUnit = ({ value, unit }) => {
    if (value === 0 || Number.isNaN(value)) {
        return React.createElement("span", { className: 'text-monospace' },
            "0 ",
            unit);
    }
    const prefixes = ['m', '', 'k', 'M', 'T'];
    const n = Math.min(Math.floor(Math.log(value) / Math.log(1000)), prefixes.length - 1);
    value /= Math.pow(1000, n);
    const printed = `${+value.toFixed(5)} ${prefixes[n]}${unit}`;
    return React.createElement("span", { className: 'text-monospace' }, printed);
};
